'use client'

import Script from 'next/script'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { EVT, track } from '@/lib/analytics'

interface AnalyticsProps {
  tagId?: string
}

export function Analytics({ tagId }: AnalyticsProps) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  // App Router doesn't fire GA page_view automatically — emit one per route.
  useEffect(() => {
    if (!tagId) return
    const qs = searchParams?.toString()
    const path = qs ? `${pathname}?${qs}` : pathname
    track(EVT.PAGE_VIEW, {
      page_path: path,
      page_title: typeof document !== 'undefined' ? document.title : undefined,
      send_to: tagId,
    })
  }, [pathname, searchParams, tagId])

  if (!tagId) return null

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${tagId}`}
        strategy="afterInteractive"
      />
      <Script id="ga-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', '${tagId}', { send_page_view: false });
        `}
      </Script>
    </>
  )
}
